export class UserModel {
    public id: number;
    public email: string;
    public time: string;
    public name: string;
    public phone: string;
    public position: string;
    public responsibleFor: string;
    public skype: string;
    public departmentId: number;
    public notifyBefore: number;
    public avatar: string;

    constructor(obj?: any) {
        this.id             = obj && obj.id             || null;
        this.email          = obj && obj.email          || '';
        this.time           = obj && obj.time           || '';
        this.name           = obj && obj.name           || '';
        this.phone          = obj && obj.phone          || '';
        this.position       = obj && obj.position       || '';
        this.responsibleFor = obj && obj.responsibleFor || '';
        this.skype          = obj && obj.skype          || '';
        this.departmentId   = obj && obj.departmentId   || null;
        this.notifyBefore   = obj && obj.notifyBefore   || null;
        this.avatar         = obj && obj.avatar         || '';
    }
}



// WEBPACK FOOTER //
// ./src/app/models/user.model.ts